<link rel="stylesheet" type="text/css" href="//fonts.googleapis.com/css?family=Bitter" />
<div [ngClass]="[ (showPopup && !startHiding) ? 'showField popup-level-' + openedPopupsCount: 'hideField']"
    class="FieldContainer" [ngStyle]="{'width':popupWidth}">

    <div [ngClass]="{'background' : showPopup}"></div>
    <div *ngIf="showPopup">
        <div class="left-title-bar"
            [ngClass]="[showRoundedCorner ? 'round-corner': '', isActivePopup() ?  'popup-header-select' : 'popup-header-deselect']">
            <span class="vertical-text">{{"lbl_options" | translate}}</span></div>
        <div class="main-modal" [ngClass]="showRoundedCorner ? 'round-corner': ''">
            <div class="header">
                <div class="head-title">
                    <div>{{titleOption | translate}}</div>
                </div>
                <span></span>
            </div>
            <div class="body main-container">
                <div class="form-group genaration-dropdown">
                    <label *ngIf="reportTitle">{{"lbl_title" | translate}}</label>
                    <input *ngIf="reportTitle" type="text" class="form-control reportTitle-text"
                        [(ngModel)]="reportTitle">
                    <label>{{"lbl_number_of_genarations" | translate}}</label>
                    <select class="form-control dropdown-list" [(ngModel)]="selectedGenaration"
                        (change)='onChange($event)'>
                        <option *ngFor='let option of dropDownData' [value]="option">{{option}}</option>
                    </select>
                </div>
            </div>


            <div class="footer">
                <div class="buttons">
                    <span><button type="button" class="btn btn-primary  btn-foot"
                            (click)="selected()">{{"lbl_save" | translate}}</button></span>
                    <span><button type=" button" class="btn btn-primary btn-foot btn-cancel element-over-hand"
                            (click)="cancel()">{{"lbl_cancel" | translate}}</button></span>
                </div>
            </div>
        </div>
    </div>

</div>